import React from 'react';
import { HomeBanner } from '../../components/home/homeBanner';
import { BeingPart } from './beignpart';
import { CategoryAuctions } from './categoryAuctions';
import { DownloadApp } from './downloadApp';
import { TestimonialSlider } from './testimonialSlider';
import { TodayAuctions } from './todayAuctions';
import { PartnersList } from './partnersList';

export class Homepage extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    //let cordinates = this.state.cordinates;
    return (
      <div>
        {/* <HomeBanner /> */}
        {/*{!is_logged && <BeingPart />}
        {is_logged && <AuctionListing />} */}
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />
        {/* <CategorySearch /> */}
        {/* <TodayAuctions /> */}
        <CategoryAuctions />
        {/* <CharityAuctions /> */}
        {/* <PinnedMap cordinates={cordinates} /> */}

        {/* <Specials /> */}
        {/* <ClientSection /> */}
        {/* <BeingPart /> */}
        {/* <TestimonialSlider/> */}

        <PartnersList />
        {/* <DownloadApp /> */}
        

      </div>
    );
  }
}
